import { Button, ButtonGroup, Modal } from '@veneer/core';

interface ModalCheckoutPayment {
  onClosePaymentInfoTapped: () => void;
  showPaymentModal: boolean;
}

const ModalCheckoutPayment = (props: ModalCheckoutPayment) => {
  return (
    <Modal
      id="payment-modal"
      closeButton
      onClose={props.onClosePaymentInfoTapped}
      show={props.showPaymentModal}
      title="Payment info"
      footer={
        <ButtonGroup>
          <Button onClick={props.onClosePaymentInfoTapped}>Close</Button>
        </ButtonGroup>
      }
    >
      <p>
        This offer is only available to active Instant Ink customers, we’re charging your project to the payment
        associated with your Instant Ink account.
      </p>
    </Modal>
  );
};

export default ModalCheckoutPayment;
